import { render, staticRenderFns } from "./TwoFactorAuthenticationSetUpModal.vue?vue&type=template&id=640b1a70"
import script from "./TwoFactorAuthenticationSetUpModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationSetUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports